export default __webpack_public_path__ + "static/media/028-fracture.e973ee3b.svg";